// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"127": "90b501caafb2","6198": "f278f7aeb74a","8357": "dd422574e14d","8990": "7d69c8cdd354",}[chunkId] + ".css"
}